import {
	Directive,
	TemplateRef,
	Input,
	AfterViewInit,
	ViewContainerRef,
	EmbeddedViewRef,
} from '@angular/core'

@Directive({
	selector: '[mvPopover]',
})
export class PopoverDirective implements AfterViewInit {
	private popover!: TemplateRef<unknown>

	constructor (private readonly vcr: ViewContainerRef) { }

	@Input('mvPopover') set popoverTemplate (value: TemplateRef<unknown>) {
		this.popover = value
	}

	ngAfterViewInit (): void {
		this.createViewRef(this.popover)
	}

	private createViewRef (templateRef: TemplateRef<unknown>): void {
		const embeddedViewRef: EmbeddedViewRef<unknown> = this.vcr.createEmbeddedView(templateRef)
		if (embeddedViewRef.rootNodes.length !== 1) {
			const error = new Error()
			error.message = 'The mvPopover directive may only contain 1 root element'
			error.name = 'MULTIPLE_ROOT_NODES_ERROR'

			throw error
		}

		embeddedViewRef.detectChanges()
	}

}
